// PrivacyPolicy.js
import React, { useEffect } from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  useEffect(() => {
    document.title = 'Privacy Policy';
  }, []);

  return (
    <div className="privacy-container">
      <header className="privacy-header">
        <h1 className="privacy-title">Nvoice: Privacy Policy</h1>
      </header>
      <div className="privacy-body">
        <p className="paragraph">When you use www.nvoice.ai (Nvoice), 
        some personal information is collected from you. However, this site has 
        been designed so that the information collected is minimal. </p>
        <p className="paragraph">This privacy policy sets out the details of the information 
        collected, the manner in which it collected, and the purposes for which it is used. 
        It may be revised from time to time, and you will be informed of the same. </p>
        <p className="paragraph">Your continued use of Nvoice signifies your acceptance 
        of the terms of this Privacy Policy.</p>

        <h2 className="section-title">Information Collected</h2>
        <ul className="list">
          <li className="list-item">When you register, Nvoice only collects from you a valid email address that you control.</li>
          <li className="list-item">When you record and create content on Nvoice you do so of your own volition. 
          Nvoice does not require you to submit any personal data nor will it process the personal data that might be 
          contained in your content.</li>
          <li className="list-item">Nvoice does not directly collect payment information. Nvoice uses Lemonsqueezy 
          (www.lemonsqueezy.com) to process payments and as a result of this integration the following items of your data 
          will be visible to Nvoice through the tools provided by Lemonsqueezy - the last 4 digits of your credit card, 
          its expiry date, the card type, the card issuer, your billing address, your billing email address, your name, 
          your country, the amount paid to Nvoice, and the taxes paid on the transaction.</li>
          <li className="list-item">For delivering emails, Nvoice uses Firebase (https://firebase.google.com/). Your email address may be 
          stored within their servers. Nvoice has access to information regarding the delivery and opening activity of 
          those emails through Firebase.</li>
          <li className="list-item">For processing your audio and summarising its transcripts, Nvoice uses APIs provided 
          by OpenAI and Microsoft. As a result, this data is transmitted between Nvoice and OpenAI /Microsoft during the 
          process of creation. Your data is not used to train their models. Further information about their privacy policy 
          can be found on the OpenAI and Microsoft websites.</li>
          {/* <li className="list-item">For creating shareable images from your notes, Nvoice uses APIs provided by Bannerbear. 
          As a result, this data is transmitted between Nvoice and Bannerbear during the process of creation, and is stored 
          on Bannerbears servers after creation. Information about their privacy policy can be found on the Bannerbear 
          website.</li> */}
          <li className="list-item">Nvoice sets cookies for authentication purposes as well as to enable essential 
          functionalities of the platform. Nvoice sets up a cookie to mark the user’s session ID, a cookie with the 
          session signature to prevent tampering and a cookie to tell the browser who the current user is. </li>
          {/*For its affiliate  program, Nvoice uses LemonSqueezy, and uses a script to track your source of sign up. For analytics, Nvoice 
          uses Plausible Analytics (a lightweight, privacy-first web analytics tool) that does not use cookies and doesn’t 
          collect any personal data whatsoever. */}
        </ul>
        <h2 className="section-title">Use of Information</h2>
        <p className="paragraph">The personal information collected will only be used to provide you the services that you 
        have subscribed to receive from Nvoice and to continually enhance your experience on Nvoice.</p>
        <h2 className="section-title">Data Retention, Deletion, and Export</h2>
        <ul className="list">
          <li className="list-item">All information collected will be retained only for as long as your account remains in existence.</li>
          <li className="list-item">The audio from your successful recordings are auto deleted within 24 hours of their recording taking place.</li>
          <li className="list-item">All content created during your use of Nvoice is not visible to other users. However, data stored on our 
          servers is not encrypted, and is retrievable to the operators of Nvoice. </li>
          {/* Nvoice uses Bubble (Bubble.io) 
          for its databases, and they use AWS RDS’s AES-256 encryption to encrypt data at rest. */}
          <li className="list-item">If you would like to export the content created by you on Nvoice, you can do so by clicking on the export 
          button on your Account tab. A CSV file and a mp3 file with the data will be downloaded to your system.</li>
          <li className="list-item">If you would like to delete the data associated with your account, you can do so in the account tab of your account.</li>
          <li className="list-item">If you would like to delete your entire account, you can do so at www.nvoice.ai.</li>
          <li className="list-item">If you would like to receive any other data related to your account, please write to support@metaspringai.com 
          requesting the same. Your request will be completed within 30 days of the confirmation of its receipt, 
          provided the data requested does not infringe on the privacy of other users.</li>
        </ul>

        <h2 className="section-title">Grievances or Questions</h2>
        <p className="paragraph">If you have any concerns or questions in relation to this Privacy Policy, you may address them by writing 
        to support@metaspringai.com</p>
       

        {/* ... and so on */}
      </div>
    </div>
  );
};

export default PrivacyPolicy;